module.exports = __webpack_public_path__ + "static/img/succeed.a3dfe2ef.png";